<template>
  <div>
    <div class="dashboard-status-organizations">
      <span class="dashboard-status-organizations-title">{{ $t('label_dashboard_status_totalEawPlatform') }}</span>
      <span class="dashboard-status-organizations-total">517</span>
    </div>
    <div class="dashboard-status-container">
      <div :key="seal.seal" class="dashboard-status-item-container" v-for="seal of seals">
        <div class="dashboard-status-item">
          <div class="dashboard-status-label">{{ $t(seal.seal) }}</div>
          <div class="dashboard-status-values-container">
            <div class="dashboard-status-values-percentage"></div>
            <div class="dashboard-status-values-count">{{ seal.percentage }}%</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "DashboardStatusTemp",
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      seals: []
    };
  },
  mounted() {
    this.formatChartData()
  },
  methods: {
    formatChartData: function () {
      this.seals = [
        {
          seal: 'label_dashboard_status_gold',
          percentage: 30
        },
        {
          seal: 'label_dashboard_status_silver',
          percentage: 48
        },
        {
          seal: 'label_dashboard_status_bronze',
          percentage: 21
        },
        {
          seal: 'label_dashboard_status_recognition',
          percentage: 1
        },
      ]
    }
  },
};
</script>
<style lang="scss" scoped>
.dashboard-status-organizations {
  text-align: center;
  padding-bottom: 5px;
  font-family: "Poppins-Regular", sans-serif;

  .dashboard-status-organizations-title {
    font-size: 0.875rem;
    font-family: "Poppins-Regular", sans-serif;
  }

  .dashboard-status-organizations-total {
    padding: 0 5px 0 10px;
    font-family: "Poppins-Bold", sans-serif;
    color: #1E4381;
    font-size: 1rem;
  }

  .dashboard-status-organizations-percentage {
    text-align: center;
    color: #1E4381;
    font-size: 0.875rem;
    font-family: "Poppins-Regular", sans-serif;
  }
}

.dashboard-status-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 10px;

}

.dashboard-status-item-container {
  flex-basis: calc(50% - 3px);
  max-width: calc(50% - 3px);
  flex-grow: 0;
  flex-shrink: 0;
  padding: 5px 5px 5px 10px;
}


.dashboard-status-item {
  background-color: #FFFFFF;
  padding: 10px 15px;
  line-height: 1;
  box-shadow: 0px 2px 6px #53381829;
}

.dashboard-status-label {
  font-size: 0.875rem;
  font-family: "Poppins-Bold", sans-serif;
}

.dashboard-status-values {
  &-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  &-percentage {
    color: #1E4381;
    font-size: 0.875rem;
    font-family: "Poppins-Regular", sans-serif;
  }

  &-count {
    color: #1E4381;
    font-size: 1.875rem;
    font-weight: 600;
    font-family: "Poppins-Bold", sans-serif;
  }
}
</style>
